import React from 'react'

const Plants = () => {
  return (
    <div>Plants</div>
  )
}

export default Plants